import FormDrawer from 'components/__new/common/form-drawer'
import React, { useState } from 'react'
import { useHistory } from 'react-router-dom';
import { ReactComponent as Blocked } from "assets/images/icons/project-icons/blocked.svg"; 

export const RestrictedFeature = () => {
    const history = useHistory();
    const [isOpen, setIsOpen] = useState(true);
    
    const handleCloseModal = () => {
        setIsOpen(false);
        history.push("/dashboard");
    }
    
    return (
        <div>
            <FormDrawer display="center" size="xl" isOpen={isOpen} setIsOpen={handleCloseModal}>
                <div className="p-6">
                    <div className="flex justify-center">
                        <div className="h-40">
                            <Blocked alt="Success" className="w-full h-full object-contain" />
                        </div>
                    </div>
                    
                    <div className='mt-4 py-2'>
                        <h3 className='text-center text-2xl font-medium text-[#101828]'>
                            Access Restricted
                        </h3>
                        <div className="text-center text-[#4A5564] font-normal text-lg">
                            This feature is only available for registered businesses. To upgrade your account, please send an email to <a href="mailto:support@earnipay.com" className='text-ep-primary-600 underline font-medium'>support@earnipay.com</a> with your request.
                        </div>
                    </div>

                    <div className="py-2 mt-4 flex justify-center gap-6">
                        <button 
                            type="button" 
                            className="btn btn-lg btn-block rounded-lg whitespace-nowrap text-white bg-ep-primary-600 h-14 text-lg" 
                            onClick={handleCloseModal}
                        >
                            Close
                        </button>
                    </div>
                </div>
            </FormDrawer>
        </div>
    )
}
